<template>
    <div>
        <div>
            <el-input class="bottom-line" style="width:320px;" :disabled="true" v-model="comRole.mobAppRoleName"></el-input>
            <i class="swb-btn swb-btn-small mt5" v-if="mobAppRoleCode == null && !readOnly" @click="showMobAppRoleDlg()">关联移动角色</i>
            <i class="swb-btn swb-btn-small mt5" v-if="mobAppRoleCode != null && !readOnly" @click="clearMobAppRole()">移除移动角色</i>
        </div>
        <el-tabs v-model="activeName" v-if="mobAppRoleCode != null">
            <el-tab-pane v-for="navTopicInfo in navTopicList" :label="navTopicInfo.name" :name="navTopicInfo.name">
                <!-- 无分组-项 -->
                <template v-if="navTopicInfo.itemList != null && navTopicInfo.itemList.length > 0">
                    <div class="group-container">
                        <el-checkbox-group v-model="checkedRescIds">
                            <template v-if="navTopicInfo.itemList != null && navTopicInfo.itemList.length > 0">
                                <div class="item-container" v-for="itemInfo in navTopicInfo.itemList">
                                    <div class="item-title">
                                        <label @change="handleCheckAllChange(itemInfo)">
                                            <el-checkbox :disabled="readOnly" :label="itemInfo.rescId">
                                                <span :class="{'font-gray2 mr5' : ctxVipLevel < itemInfo.sysResc.forVip}">{{itemInfo.dispName}}</span>
                                                <span v-if="ctxVipLevel < itemInfo.sysResc.forVip" class="font-red">【{{vipLevel[itemInfo.sysResc.forVip]}}】及以上</span>
                                                <span class="font-gray3" v-if="itemInfo.sysResc.desc != null">（{{itemInfo.sysResc.desc}}）</span>
                                            </el-checkbox>
                                        </label>
                                    </div>
                                    <template v-if="itemInfo.actionList != null && itemInfo.actionList.length > 0">
                                        <div class="item-content">
                                            <div class="switch-list clearfix ml15">
                                                <el-checkbox-group v-model="itemInfo.checkedActions">
                                                    <div class="switch-item ellipsis-1" v-for="action in itemInfo.actionList" style="width: auto;margin-right: 30px">
                                                        <el-checkbox :disabled="readOnly || checkedRescIds.indexOf(itemInfo.rescId) < 0" :label="action.code" @change="handleCheckChange(action.code, itemInfo.rescId)">
                                                            <span>{{action.name}}</span>
                                                        </el-checkbox>
                                                    </div>
                                                </el-checkbox-group>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </template>
                        </el-checkbox-group>
                    </div>
                </template>

                <!-- 分组-项 -->
                <template v-if="navTopicInfo.groupList != null && navTopicInfo.groupList.length > 0">
                    <div class="group-container" v-for="groupInfo in navTopicInfo.groupList">
                        <div class="content-caption dashed">
                            <span class="font-gray2 mr5">{{groupInfo.name}}</span>
                            <!--<label @change="handleCheckAllChange(itemInfo)">-->
                            <!--<el-checkbox>-->
                            <!--<span class="font-gray2 mr5">{{groupInfo.name}}</span>-->
                            <!--</el-checkbox>-->
                            <!--</label>-->
                        </div>
                        <el-checkbox-group v-model="checkedRescIds">
                            <template v-if="groupInfo.itemList != null && groupInfo.itemList.length > 0">
                                <div class="item-container" v-for="itemInfo in groupInfo.itemList">
                                    <div class="item-title">
                                        <label @change="handleCheckAllChange(itemInfo)">
                                            <el-checkbox :disabled="readOnly" :label="itemInfo.rescId">
                                                <span :class="{'font-gray2 mr5' : ctxVipLevel < itemInfo.sysResc.forVip}">{{itemInfo.dispName}}</span>
                                                <span v-if="ctxVipLevel < itemInfo.sysResc.forVip" class="font-red">【{{vipLevel[itemInfo.sysResc.forVip]}}】及以上</span>
                                                <span class="font-gray3" v-if="itemInfo.sysResc.desc != null">（{{itemInfo.sysResc.desc}}）</span>
                                            </el-checkbox>
                                        </label>
                                    </div>
                                    <template v-if="itemInfo.actionList != null && itemInfo.actionList.length > 0">
                                        <div class="item-content">
                                            <div class="switch-list clearfix ml15">
                                                <el-checkbox-group v-model="itemInfo.checkedActions">
                                                    <div class="switch-item ellipsis-1" v-for="action in itemInfo.actionList" style="width: auto;margin-right: 30px">
                                                        <el-checkbox :disabled="readOnly || checkedRescIds.indexOf(itemInfo.rescId) < 0" :label="action.code" @change="handleCheckChange(action.code, itemInfo.rescId)">
                                                            <span>{{action.name}}</span>
                                                        </el-checkbox>
                                                    </div>
                                                </el-checkbox-group>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </template>
                        </el-checkbox-group>
                    </div>
                </template>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    import comnApi from '../../api/comn';
    import settingApi from '../../api/setting'
    import servicerAuthxApi from '../../api/servicerAuthx'
    import userApi from '../../api/user'
    import { openMobAppRoleSelectDlg } from './selectDlg';

    export default {
        name: 'swb-mob-app-role-resc',
        props: ['roleId', 'bizUnitType', 'readOnly'],
        data: function () {
            return {
                checkedRescIds: [],
                ownRescList: [],
                theLoading: null,
                vipLevel: {},
                ctxVipLevel: 0,
                navTopicList: [],
                navItemList: [],
                activeName: null,
                mobAppRoleCode: null,
                comRole: {},
            }
        },
        created: function () {
            this.vipLevel = getEnumMap("vipLevel", "value2text");
            this.ctxVipLevel = userApi.getScopeEntityVipLevel() || 0;
            //
            //获取已关联的资源
            this.getServicerComRole();
        },
        methods: {
            getServicerComRole: function () {
                let self = this;
                let postData = {
                    id: self.roleId,
                };
                servicerAuthxApi.getServicerComRole(postData, function (retult) {
                    if(retult.type == "info") {
                        let comRole = retult.data;
                        self.comRole = Utils.merge({}, comRole);
                        self.mobAppRoleCode = comRole.mobAppRoleCode;
                        if(!Utils.isNoB(comRole.mobAppRoleCode)) {
                            self.getMobAppRoleRescListForOwn();
                        }
                    } else {
                        MsgBox.warning(retult.message);
                    }
                })
            },
            getMobAppRoleRescListForOwn(){
                let self = this;
                let postData = {};
                postData.roleId = self.roleId;
                let theLoading = MsgBox.loading();
                servicerAuthxApi.getMobAppRoleRescListForOwn(postData, function (result) {
                    theLoading.hide();
                    // console.log("回显数据...", result);
                    if(result.type == 'info') {
                        self.ownRescList = result.data;
                        self.getMiniAppTopicList();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 获取主题-分组
            getMiniAppTopicList: function () {
                let self = this;
                let postData = {};
                if(self.mobAppRoleCode == "dispatching") {
                    postData.appId = "servicerServc";
                } else {
                    postData.appId = "servicerEngin";
                }
                postData.bizUnitType = self.bizUnitType;
                settingApi.getMiniAppNavTopicListByContext(postData, function (result) {
                    if(result.type == 'info') {
                        let topicList = result.data;
                        self.activeName = topicList[0].name || '';
                        //
                        self.setSysRescForEchoDisplay(topicList);
                        //
                        self.navTopicList = Utils.merge([], topicList);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 设置回显
            setSysRescForEchoDisplay: function (topicList) {
                let self = this;
                for(let i = 0; i < topicList.length; i++) { // 主题
                    let topicInfo = topicList[i];
                    // 无分组-项
                    let itemList = topicInfo.itemList || [];
                    if(itemList != null && itemList.length > 0) {
                        self.setItemList(self, itemList);
                    }
                    // 分组-项
                    let groupList = topicInfo.groupList || [];
                    if(groupList.length > 0) {
                        for(let j = 0; j < groupList.length; j++) {
                            let groupInfo = groupList[j];
                            //
                            self.setItemList(self, groupInfo.itemList || []);
                        }
                    }
                }
            },
            setItemList: function (self, itemList) {
                if(itemList.length > 0) {
                    for(let n = 0; n < itemList.length; n++) {
                        let itemInfo = itemList[n];
                        itemInfo.checkedActions = [];
                        //
                        self.ownRescList.forEach(function (ownResc) {
                            if(itemInfo.rescId == ownResc.rescId) {
                                self.checkedRescIds.add(itemInfo.rescId);
                                if(ownResc.actionList != null) {
                                    itemInfo.checkedActions = ownResc.actionList;
                                }
                            }
                        });
                        self.navItemList.push(itemInfo);
                    }
                }
            },
            //

            handleCheckAllChange(itemInfo) {
                let index = this.checkedRescIds.indexOf(itemInfo.rescId);
                if(index > -1) {
                    itemInfo.checkedActions = itemInfo.actionList.pluck("code");
                } else {
                    itemInfo.checkedActions = [];
                }
                //
                let navItemList = this.navItemList || [];
                let currItem = navItemList.find(function (item) {
                    return item.rescId == itemInfo.rescId;
                });
                currItem.checkedActions = itemInfo.checkedActions;
                this.navItemList = Utils.merge([], navItemList);
            },
            handleCheckChange: function (code, rescId) {
                this.navItemList.forEach(function (navItem) {
                    if(navItem.rescId == rescId) {
                        let checkedActions = navItem.checkedActions || [];
                        if(checkedActions.indexOf(code) < 0) {
                            checkedActions.push(code);
                        } else {
                            checkedActions.remove(code);
                        }
                    }
                });
            },
            //
            showMobAppRoleDlg: function () {
                let self = this;
                let comRole = this.comRole;
                openMobAppRoleSelectDlg(this, comRole.id, comRole.mobAppRoleCode, function () {
                    self.getServicerComRole();
                });
            },
            clearMobAppRole(){
                //弹出确认框
                let self = this;
                this.$confirm('确认消除所有移动功能?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let comRoleId = self.comRole.id;
                    servicerAuthxApi.updateServicerComRoleMobAppRoleForClear(comRoleId, function (result) {
                        if(result.type == 'info') {
                            self.$message.success("清除成功!");
                            self.$emit("handle-change");
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {

                });
            },
            getDlgResult(){
                let roleId = this.roleId;
                let resultData = {};
                resultData.roleId = roleId;
                resultData.servicerComRoleRescs = [];
                //
                let checkedRescIds = this.checkedRescIds;
                this.navItemList.forEach(function (navItem) {
                    if(checkedRescIds.indexOf(navItem.rescId) >= 0) {
                        let servicerComRoleResc = {
                            roleId: roleId,
                            rescId: navItem.rescId,
                            actionList: navItem.checkedActions
                        };
                        resultData.servicerComRoleRescs.add(servicerComRoleResc);
                    }
                });
                let result = {};
                result.data = resultData;
                result.type = 'info';
                return result;
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/compo/authx/MobAppRoleResc.vue